import { faFileExcel } from '@fortawesome/free-solid-svg-icons'
import React, { useEffect, useState } from 'react'

import { Col, Row } from 'react-bootstrap'
import { Title, Card, SelectedDates, Button, Select, CustomDate } from 'src/components'

import { useDispatch, useSelector } from 'react-redux'
import {
  actionTypes,
  exportInventoryLastInventory,
  exportWarehouseKardex,
  getWarehouseKardexReport,
  getWarehouseLite,
} from 'src/actions/warehouse.actions'
import { selectKardexReport } from 'src/selectors/warehouse.selector'

import { loadingSelector } from 'src/selectors/loading.selector'

import { SelectWarehouses } from 'src/components/custom/MutipleSelects/SelectorWarehouses/SelectorWarehouses'
import {
  InventoryKardexTypeEnum,
  InventoryKardexTypeOptions,
} from 'src/content/Reports/InventoryKardex/InventoryKardexTypes'
import { formatDateFromMillis } from 'src/utils/formatters'
import { handlerError, hasErrors } from 'src/selectors/error.selector'
import { showAlert } from 'src/actions/alert.actions'

const movementsOptions = [
  {
    label: 'Con movimientos',
    value: 1,
  },
  {
    label: 'Sin movimientos',
    value: 2,
  },
  {
    label: 'Todos',
    value: 3,
  },
]

export const InventoryKardex = () => {
  const dispatch = useDispatch()

  const loadingKardex = useSelector(state =>
    loadingSelector([actionTypes.DOWNLOAD_GENERAL_KARDEX])(state),
  )
  const hasErrorKardex = useSelector(state =>
    hasErrors([actionTypes.DOWNLOAD_GENERAL_KARDEX])(state),
  )

  const loadingLastMovement = useSelector(state =>
    loadingSelector([actionTypes.DOWNLOAD_INVENTORY_LAST_MOVEMENT])(state),
  )
  const hasErrorLastMovement = useSelector(state =>
    hasErrors([actionTypes.DOWNLOAD_INVENTORY_LAST_MOVEMENT])(state),
  )

  const loading = loadingKardex || loadingLastMovement

  const [type, setType] = useState(InventoryKardexTypeOptions[0])

  const [filters, setFilters] = useState({
    startDate: new Date().setHours(0, 0, 0, 0).valueOf(),
    endDate: new Date().setHours(23, 59, 59, 999).valueOf(),
    warehouses: [],
  })

  const [flag, setFlag] = useState({
    movement: false,
    lastMovement: false,
  })

  const disabledMovements = !filters.startDate || !filters.endDate
  const disabledLastMovement = !filters.endDate
  const disabled =
    filters.warehouses?.length === 0 &&
    (type.value === InventoryKardexTypeEnum.LAST_MOVEMENT
      ? disabledLastMovement
      : disabledMovements)

  useEffect(() => {
    dispatch(getWarehouseLite())
  }, [])

  useEffect(() => {
    if (loadingKardex) setFlag({ ...flag, movement: true })
    else if (flag.movement) {
      setFlag({ ...flag, movement: false })
      if (hasErrorKardex) dispatch(showAlert(handlerError(hasErrorKardex.message)))
    }
  }, [loadingKardex])

  useEffect(() => {
    if (loadingLastMovement) setFlag({ ...flag, lastMovement: true })
    else if (flag.lastMovement) {
      setFlag({ ...flag, lastMovement: false })
      if (hasErrorLastMovement)
        dispatch(showAlert(handlerError(hasErrorLastMovement.message)))
    }
  }, [loadingLastMovement])

  const setUp = () => {
    const params = {
      warehouseIds: filters.warehouses.map(w => w.id).join(','),
      start: filters?.startDate ?? new Date().setHours(0, 0, 0, 0).valueOf(),
      end: filters?.endDate ?? new Date().valueOf(),
      productIds: [],
    }
    if (type.value === InventoryKardexTypeEnum.MOVEMENT) {
      dispatch(exportWarehouseKardex(params))
    } else {
      const dateName = formatDateFromMillis(params.end, null, true)
      dispatch(exportInventoryLastInventory(params, dateName))
    }
  }

  return (
    <div>
      <Title title={'Reporte de Inventario'} />

      <Card title={'Kardex de Bodega'} white>
        <Row>
          <Col xl={3} lg={3} md={4} sm={6} xs={12}>
            <Select
              label={'Tipo de reporte'}
              options={InventoryKardexTypeOptions}
              value={type}
              onChange={setType}
            />
          </Col>
          <Col xl={9} lg={9} md={8} sm={6} xs={12}>
            <Row>
              {type?.value === InventoryKardexTypeEnum.MOVEMENT && (
                <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                  <SelectedDates
                    nonExecute
                    onDateChange={(start, end) => {
                      setFilters({ ...filters, startDate: start, endDate: end })
                    }}
                  />
                </Col>
              )}
              {type.value === InventoryKardexTypeEnum.LAST_MOVEMENT && (
                <Col xl={6} lg={6} md={6} sm={12} xs={12}>
                  <CustomDate
                    label={'Fecha de corte'}
                    onDayChange={date =>
                      setFilters({ ...filters, endDate: date?.setHours(23, 59, 59, 999) })
                    }
                  />
                </Col>
              )}
            </Row>
          </Col>

          <Col xs={12} sm={6} md={6} lg={6} xl={6}>
            <SelectWarehouses
              label={'Bodegas'}
              noMultiple={type.value === InventoryKardexTypeEnum.MOVEMENT}
              clear={type.value === InventoryKardexTypeEnum.MOVEMENT}
              onChange={list =>
                setFilters({
                  ...filters,
                  warehouses: list,
                })
              }
            />
          </Col>
          <Col xl={12} className="mt-2">
            <Row className={'container-buttons'}>
              <Button
                color={'accent'}
                icon={faFileExcel}
                disabled={disabled}
                loading={loading}
                onClick={() => {
                  setUp(true)
                }}>
                Descargar reporte
              </Button>
            </Row>
          </Col>
        </Row>
      </Card>
    </div>
  )
}
